export const SITE_NAME = "Asher Jewels PH";
export const SITE_URL = "https://shop.asherjewels.com.ph";
export const DEFAULT_SHARE_IMAGE = "https://ecomapi.asherjewels.com.ph/img/banner.jpg";
export const BUSINESS_PHONE = "+63 970 757 8888";
export const BUSINESS_EMAIL = "pngbcustomerservice@gmail.com";

export function toAbsoluteUrl(path = "/") {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function toAbsoluteImageUrl(path) {
  if (!path) return DEFAULT_SHARE_IMAGE;
  if (/^https?:\/\//i.test(path)) return path;
  const normalized = String(path).replace(/^\/+/, "");
  return toAbsoluteUrl(`/${normalized}`);
}

export function clampDescription(text, fallback = "") {
  const source = String(text || fallback || "").replace(/\s+/g, " ").trim();
  if (!source) return "";
  if (source.length <= 160) return source;
  return `${source.slice(0, 157).trim()}...`;
}
